import { CommonOrderQtyModel } from "./order-completion-qty/common-order-qty.model";

export class OpPlannedCompletionModel extends CommonOrderQtyModel{
    operation: string;
    operationName: string;
    sequence: number;
    pendingWip: number; // pre op compeletd but current op not completed

    constructor(operation: string, operationName: string, sequence: number, pendingWip: number, plannedQuantity: number, completedQuantity: number, plannedCompletionDate: string) {
        super(plannedQuantity, completedQuantity, plannedCompletionDate);
        this.operation = operation;
        this.operationName = operationName;
        this.sequence = sequence;
        this.pendingWip = pendingWip;
    }
}





